export { setupMonitoring, assignUser } from "./window";
import { datadogRum } from "@datadog/browser-rum";
export const captureException = (error: unknown, context?: object) => datadogRum.addError(error, context);
